import { useEffect, useState } from "react"
import { GetRequest } from "./ApiHandler"

export const useSharedPipelinePermission = (
    selectedPipelineId,
    customerId,
    loginUserId,
    userType,
    headers,
    extras,
    moduleName
) => {
    const [authObject, setAuthObject] = useState({ permissionAssigned: null, canEdit: false })
    const isSoftware_owner = Number(userType) === 1

    useEffect(() => {
        let ignore = false

        const resolvePermission = (perms) => {
            if (!perms) return null
            if (perms.can_edit) return "can_edit"
            if (perms.can_download) return "can_download"
            if (perms.can_view) return "can_view"
            return null
        }

            ; (async () => {
                try {
                    if (isSoftware_owner) {
                        if (!ignore) setAuthObject({ permissionAssigned: "can_edit", canEdit: true })
                        return
                    }

                    if (!selectedPipelineId) return

                    const res = await GetRequest(
                        `lead/getSharedPipelineData/${customerId}/${selectedPipelineId}/${moduleName}/${loginUserId}`,
                        { headers },
                        extras
                    )

                    if (res.success === false || res.status === "fail") {
                        // toast.error(res.message)
                        return
                    }

                    const pipelineAddedBy = res.data?.added_by
                    const sharedUsersRaw = res.data?.shared_to

                    let parsedSharedUsers = []
                    try {
                        parsedSharedUsers = sharedUsersRaw ? JSON.parse(sharedUsersRaw) : []
                    } catch (parseErr) {
                        console.error("Failed to parse shared_to", parseErr)
                        parsedSharedUsers = []
                    }

                    if (!pipelineAddedBy) {
                        if (!ignore) setAuthObject({ permissionAssigned: null, canEdit: false })
                        return
                    }

                    const isOwner = extras?.customer_details?.id === pipelineAddedBy
                    const isShareExist =
                        Array.isArray(parsedSharedUsers) && parsedSharedUsers.length !== 0
                            ? parsedSharedUsers.find((c) => String(c.id) === String(loginUserId))
                            : null

                    const permissionAssigned = isShareExist
                        ? resolvePermission(isShareExist?.permissions?.[0])
                        : null

                    console.log('permissionAssigned', permissionAssigned)

                    const canEdit = isOwner || permissionAssigned === "can_edit"

                    if (!ignore) setAuthObject({ permissionAssigned, canEdit })
                } catch (error) {
                    console.error("useSharedPipelinePermission error:", error)
                    // showServerError()
                }
            })()

        return () => {
            ignore = true
        }
    }, [selectedPipelineId, moduleName])

    // permissionAssigned can be "can_edit" | "can_download" | null
    // canEdit is derived for convenience; if permissionAssigned === "can_download",
    // treat download-only users as edit-disabled downstream.
    return { permissionAssigned: authObject?.permissionAssigned, canEdit: authObject?.canEdit }
}